import React, { Component } from "react"
import { getCDNUrl } from "../../../commons/CommonFunctions";
import { CapitalizeFirstLetter } from "../../../utils/StringUtility";
import { Link, NavLink } from "react-router-dom";
import * as _ from "lodash";
import { authService } from "../../../auth";
import {redirectToCircle, redirectToCircleHashTag, redirectToProfileHashTags} from './HashtagsCommonFunction';

class CommonHashTagsTopContributors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated()
        }
    }


    getOptimizedImage = (personalInfo) => {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }
        return personalInfo.profileImage;
    }


    getCircleOptimizedImage = (circleInfo) =>{
        if (circleInfo.resizedProfileImages && circleInfo.resizedProfileImages['300x300'] != null) {
            return circleInfo.resizedProfileImages['300x300'];
        }
        return circleInfo.imageUrl;
    }

    getOptimizedCoverImage = (personalInfo) => {
        let image = "https://cdn.dscovr.com/images/prof-banner.webp";
        if(personalInfo.coverImage){
            image =   personalInfo.coverImage;
        }

         return image;
    }

    render() {
        return (
            <div className="youmayknow itemBox">
                <div className= {"invitpeopleblk" + (this.props.item.userType === "COMPANY" ? " orgnzName" : "")}>
                    {this.props.item.type === 'INDIVIDUAL' ?
                        <>
                            <div className="bannImgbx">
                                {this.props.item.personalInfo.coverImage ?
                                    <img src={getCDNUrl(this.getOptimizedCoverImage(this.props.item.personalInfo))} alt="" /> :
                                    <img src="https://cdn.dscovr.com/images/prof-banner.webp"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/prof-banner.png"
                                        }} alt="" />}
                                <figure onClick={(e) => {
                                    e.preventDefault();
                                    redirectToProfileHashTags(this.props.slug,this.props.item.customUrl)
                                }} style={{ cursor: 'pointer' }} className="users">{this.props.item && this.props.item.originalProfileImage ?
                                    <img src={getCDNUrl(this.getOptimizedImage(this.props.item.personalInfo))} alt="" /> :
                                    <img src="https://cdn.dscovr.com/images/users1.webp" onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://cdn.dscovr.com/images/users1.png"
                                    }} alt="" />}
                                </figure>
                            </div>
                            <div className="youmayknbottinfo">
                                <div className="youmayknbottinfoTop">
                                    <h5 onClick={(e) => {
                                        e.preventDefault();
                                        redirectToProfileHashTags(this.props.slug,this.props.item.customUrl)
                                    }}>{CapitalizeFirstLetter(this.props.item.username)}</h5>
                                    <p>
                                        {
                                            (this.props.item.personalInfo && (this.props.item.personalInfo.persona || this.props.item.personalInfo.otherInfo)) &&
                                            <span className="brif">{this.props.item.personalInfo.otherInfo ? this.props.item.personalInfo.otherInfo : this.props.item.personalInfo.persona}</span>
                                        }
                                        {
                                            (this.props.item.addressDetail && this.props.item.addressDetail.country) &&
                                            <span className="address">{this.props.item.addressDetail.country}</span>
                                        }
                                        {
                                            (this.props.item.mutualConnectCount && this.props.item.mutualConnectCount > 1) ?
                                                <>
                                                    <span
                                                        style={{ cursor: 'pointer' }}>{this.props.item.mutualConnectCount} mutual connects
                                                    </span>
                                                </>
                                                : (this.props.item.mutualConnectCount === 1 ?
                                                    <>
                                                        <span
                                                            style={{ cursor: 'pointer' }}>
                                                            1 mutual connect
                                                        </span>
                                                    </> : '')
                                        }
                                    </p>
                                </div>
                            </div>
                        </> : this.props.item.type === 'COMPANY' ?
                            <>
                                <div className="bannImgbx">
                                    <img src={!_.isNull(this.props.item) && !_.isNull(this.props.item.personalInfo) ? getCDNUrl(this.getOptimizedCoverImage(this.props.item.personalInfo)) : 'https://cdn.dscovr.com/images/prof-banner.webp'}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/prof-banner.png"
                                        }} alt="" />
                                    <figure onClick={(e) => {
                                        e.preventDefault();
                                        redirectToProfileHashTags(this.props.slug,this.props.item.customUrl)
                                    }} style={{ cursor: 'pointer' }} className="users">{this.props.item &&
                                        this.props.item.personalInfo.profileImage ?
                                        <img src={getCDNUrl(this.getOptimizedImage(this.props.item.personalInfo))} alt="" /> :
                                        <img src="https://cdn.dscovr.com/images/DefaultBusiness.webp" onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/DefaultBusiness.png"
                                        }} alt="" />}
                                    </figure>
                                </div>
                                <div class="youmayknbottinfo">
                                    <div class="youmayknbottinfoTop">
                                        <h5 onClick={(e) => {
                                            e.preventDefault();
                                            redirectToProfileHashTags(this.props.slug,this.props.item.customUrl)
                                        }}><span>{this.props.item.username}</span></h5>
                                        <p>
                                            {
                                                (this.props.item.persona) &&
                                                <span className="brif">{this.props.item.persona}</span>
                                            }
                                            {
                                                this.props.item.addressDetail && this.props.item.addressDetail.country &&
                                                <span className="address">{this.props.item.addressDetail.country}</span>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </> :
                            <>
                                <div className="bannImgbx">
                                    <img
                                        src={this.props.item.coverImage ? getCDNUrl(this.props.item.coverImage) : "https://cdn.dscovr.com/images/prof-banner.webp"}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/prof-banner.png"
                                        }} alt="" />
                                    <figure className="users" onClick={(e) => {e.preventDefault(); redirectToCircleHashTag(this.props?.item?.customUrl)}} style={{ cursor: 'pointer' }}><img
                                        src={this.props.item.imageUrl ? getCDNUrl(this.getCircleOptimizedImage(this.props.item)) : "https://cdn.dscovr.com/images/circleDefault.webp"}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://cdn.dscovr.com/images/circleDefault.png"
                                        }}
                                        alt="" /></figure>
                                </div>
                                <div className="youmayknbottinfo">
                                    <div className="youmayknbottinfoTop">
                                        <h5 onClick={(e) => {
                                            e.preventDefault();
                                            redirectToCircleHashTag(this.props.item.customUrl)
                                        }}><span>{this.props.item.username}</span></h5>
                                        <p>
                                            {
                                                (this.props.item.persona) &&
                                                <span className="brif">{this.props.item.persona}</span>
                                            }
                                            {
                                                this.props.item.location && this.props.item.location.country &&
                                                <span
                                                    className="address">{this.props.item.location.country}</span>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </>

                    }
                </div>
            </div>
        )
    }
}

export default CommonHashTagsTopContributors;